<template lang="pug">
  #app
    preloader(@loaded="loaded = true", v-if="!loaded")
    border-nav(v-if="showBorderNav")
    transition(name="slideNav")
      main-nav(v-if="mainNavVisibility")
    transition(name="fade", appear)
      router-view(:key="$route.fullPath", @showBorderNav="showBorderNav = true", v-if="loaded")
    transition(name="fade", appear)
      background(v-if="loaded")
    svg-filter
</template>

<script>
import background from '@/components/background.vue'
import borderNav from '@/components/borderNav.vue'
import mainNav from '@/components/mainNav.vue'
import svgFilter from '@/components/svgFilter.vue'
import preloader from '@/components/preloader.vue';
export default {
  name: 'App',
  data() {
    return {
      loaded: false,
      closePreloader: false,
      showBorderNav: false
    }
  },
  computed: {
    mainNavVisibility() {
      return this.$store.state.mainNav
    }
  },
  components: {
    background,
    borderNav,
    mainNav,
    svgFilter,
    preloader
  }
}
</script>

<style lang="scss">
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to {
  opacity: 0
}

// anatomy transition
.slideRight-enter-active, .slideRight-leave-active {
  transition: all 3s
}
.slideRight-enter, .slideRight-leave-to {
  transform: translateY(-50%) translate(50px) rotate(-90deg);
  opacity: 0;
}

// mainNav transition
.slideNav-enter-active {
  animation: slideNav 2s cubic-bezier(.36,.67,.55,.77)
}
.slideNav-leave-active {
  animation: slideNav 1.6s linear reverse
}

@keyframes slideNav {
  0% {
    opacity: 0;
    background-size: 0% 100%;
    transform: translate(100%, 0)
  }
  10% {
    background-size: 18% 100%;
  }
  50% {
    opacity: 1;
    background-size: 90% 100%;
    transform: translate(0%, 0)
  }
  100% {
    background-size: 200% 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue